import Api from "../../Services/Api";
import { toastr } from "react-redux-toastr";

export const DOCUMENTDATA = "riskwell/fetch/DOCUMENTDATA";
export const DOCUMENTFETCHFAIL = "riskwell/fetch/DOCUMENTFETCHFAIL";
export const LOGGEDINLOADER = "riskwell/fetch/LOGGEDINLOADER";
export const DOCUMENTDATAFAILURE = "riskwell/fetch/DOUCMENTDATAFAILURE";
export const RESETDATA = "riskwell/fetch/RESETDATA";

export const DocumentData = (Data) => {
  return {
    type: DOCUMENTDATA,
    payload: Data,
  };
};

export const DocumentDataFailure = (err) => {
  return {
    type: DOCUMENTDATAFAILURE,
    payload: err,
  };
};

export const DocumentFetchFail = (error) => {
  return {
    type: DOCUMENTFETCHFAIL,
    payload: error,
  };
};

export const loggedInLoader = (bool) => {
  return {
    type: LOGGEDINLOADER,
    payload: bool,
  };
};

export const resetData = () => {
  return {
    type: RESETDATA,
  };
};

export const FetchDocumentData = (params) => async (dispatch) => {
  try {
    dispatch(loggedInLoader(true));
    let result = await Api.getCommonDocumentsList(params);

    if (result.status === 200 && result.message === "Success") {
      dispatch(resetData());
      if (params.type == "projectdocs") {
        dispatch(DocumentData(result.projectDocuments));
      } else if (params.type == "riskregisterdocs") {
        dispatch(DocumentData(result.riskRegisterDocuments));
      } else if (params.type == "riskmitigationdocs") {
        dispatch(DocumentData(result.riskregisterActionDocument));
      } else if(params.type == "taskregisterdocs") {
        dispatch(DocumentData(result.taskRegisterDocuments));
      }else if(params.type == "taskactiondocs") {
        dispatch(DocumentData(result.taskActionDocuments));
      } 
      dispatch(loggedInLoader(false));
    }
    //  else if (result.statusText === "Unauthorized") {
    //   dispatch(DocumentDataFailure(result.statusText));
    //   toastr.error(result.statusText);
    // }
     else {
      dispatch(DocumentData([]));
      dispatch(DocumentFetchFail(result.message));
      dispatch(loggedInLoader(false));
    }
  } catch (error) {
    dispatch(loggedInLoader(false));
    dispatch(DocumentFetchFail(error));
  }
};

export const FetchDocumentDataByRiskId = (params) => async (dispatch) => {
  try {
    dispatch(loggedInLoader(true));
    let result = await Api.getDocumentsByRiskId(params);
    dispatch(loggedInLoader(false));
    if (result.status === 200 && result.message === "Success") {
      dispatch(resetData());
      dispatch(DocumentData(result.riskRegisterDocuments));
    } 
    // else if (result.statusText === "Unauthorized") {
    //   dispatch(DocumentDataFailure(result.statusText));
    //   toastr.error(result.statusText);
    // }
     else {
      dispatch(DocumentData([]));
      dispatch(DocumentFetchFail(result.message));
    }
  } catch (error) {
    dispatch(loggedInLoader(false));
    dispatch(DocumentFetchFail(error));
  }
};

export const deleteDocumentById = (params) => async (dispatch) => {
  try {
    dispatch(loggedInLoader(true));
    let result = await Api.deleteDocumentById(params);
    dispatch(loggedInLoader(false));
    if (result.status === 200 && result.message === "Success") {
      dispatch(resetData());
    }
    //  else if (result.statusText === "Unauthorized") {
    //   dispatch(DocumentDataFailure(result.statusText));
    //   toastr.error(result.statusText);
    // }
     else {
      dispatch(DocumentData([]));
    }
  } catch (error) {
    dispatch(loggedInLoader(false));
  }
};
